import NewButton from '$tablet-app/src/app/components/Button/NewButton';
import Row from '$tablet-app/src/app/components/Row';
import Spacer from '$tablet-app/src/app/components/Spacer';
import { color } from '$tablet-app/src/app/theme';
import React, { FC } from 'react';
import styled from 'styled-components/native';

interface CalendarItemDetailsHeaderProps {
  onPressDelete?: () => void;
  onPressEdit?: () => void;
  onPressCancel?: () => void;
}

const CalendarItemDetailsHeader: FC<CalendarItemDetailsHeaderProps> = ({
  onPressDelete,
  onPressEdit,
  onPressCancel,
}) => (
  <HeaderRow>
    {onPressDelete ? (
      <NewButton
        icon="trash"
        variant="text"
        size="small"
        onPress={onPressDelete}
        testID="delete-calendar-item-button"
      />
    ) : null}

    <Spacer width="8px" />

    {onPressEdit ? (
      <NewButton
        icon="edit"
        variant="text"
        size="small"
        onPress={onPressEdit}
        testID="edit-calendar-item-button"
      />
    ) : null}

    <Spacer width="8px" />

    {onPressCancel ? (
      <NewButton
        icon="times"
        variant="text"
        size="small"
        onPress={onPressCancel}
      />
    ) : null}
  </HeaderRow>
);

const HeaderRow = styled(Row)`
  padding: 8px;
  justify-content: flex-end;
  border-bottom-color: ${color.border};
  border-bottom-width: 1px;
`;

export default CalendarItemDetailsHeader;
